import { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import AppTopbar from './AppTopbar';
// import AppConfig from './AppConfig';
import useAuth from "../src/hooks/useAuth";

// import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import './AppCelebration.css';

import { Dashboard } from './components/dashbord';
import { User } from './components/user';
import { Page } from './components/page';
import { Role } from './components/role';
import { Profile } from './components/profile';
import { Lead } from './components/lead';
import { Contact } from './components/contact_Person';
import { MyLead } from './components/myLead';
import { Source } from './components/source';
import { Status } from './components/status';
import { Department } from './components/department';
import { PaymentMode } from './components/paymentMode';
import { Device } from './components/device';
import { Country } from './components/country';
import { City } from './components/city';
import { State } from './components/state';
import { SubscriptionPlan } from './components/subscriptionMast';
import { Customer } from './components/customer';
import { PlanStatus } from './components/planStatus';
import { PurposeOfConnection } from './components/purposeOfConnection';
import { Accessories } from './components/accessories';
import { EmailTemplate } from './components/emailTemplate';
import { Support } from './components/support';
import { LoginHistory } from './components/loginHistory';
import { CustomerReport } from './components/customerProgressReport';
import { LeadProgressReport } from './components/LeadProgressReport';
import IdleLogout from './components/IdleLogout/idleLogout';
import { SalesReport } from './components/SalesReport/salesReport';
import { RenewalReport } from './components/RenewalReport';
import { DuplicatLead } from './components/duplicateLead';
import { LeadAllocation } from './components/leadAllocation';
import { Signature } from './components/signature';


const App = () => {
    const [menuActive, setMenuActive] = useState(false);
    const [menuMode, setMenuMode] = useState('horizontal');

    const [colorScheme, setColorScheme] = useState('light');
    const [menuTheme, setMenuTheme] = useState('layout-sidebar-white');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [topbarUserMenuActive, setTopbarUserMenuActive] = useState(false);
    const [topbarNotificationMenuActive, setTopbarNotificationMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(false);
    // const [logoColor, setLogoColor] = useState('white');
    // const [componentTheme, setComponentTheme] = useState('blue');
    // const [logoUrl, setLogoUrl] = useState('assets/layout/images/logo-dark.svg');

    const copyTooltipRef = useRef();
    const location = useLocation();
    const { loginObj, pageFeatures, hasPermission } = useAuth();
    // console.log("loginObj", loginObj);
    // console.log("pageFeatures", pageFeatures);

    let menuClick = false;
    // let searchClick = false;
    let userMenuClick = false;
    let notificationMenuClick = false;
    let configClick = false;

    const dashboardUrls = ["dashboard"];
    const leadUrls = ["contact", "lead", "mylead", "customer", "leadAllocation", "signature"];
    const masterUrls = ["subscription_Plan", "source", "status", "department", "paymentMode", "device", "country", "state", "city", "PlanStatus", "purposeOfConnection", "accessories", "emailTemplate"];
    const settingUrls = ["role", "user", "page", "support",];
    const reportUrls = ["leadProgressReport", "customerReport", "loginHistory", "salesReport", "renewalReport"];

    const breadcrumb = [
        { path: '/dashboard', parent: 'Dashboard', label: 'Dashboard' },
        { path: '/login', parent: 'Login', label: 'Login' },
        { path: '/profile', parent: 'Profile', label: 'Profile' }
    ];

    const menu = [];
    const menuMap = {};

    const addMenuSection = (label, icon) => {
        if (!menuMap[label]) {
            let section = { label, icon, items: [] };
            menu.push(section, { separator: true });
            menuMap[label] = section;
        }
    };

    if (pageFeatures.some(page => (page.permission && dashboardUrls.includes(page.url)))) addMenuSection('Dashboard', 'pi pi-fw pi-home');
    if (pageFeatures.some(page => (page.permission && leadUrls.includes(page.url)))) addMenuSection('Lead', 'pi pi-fw pi-table');
    if (pageFeatures.some(page => (page.permission && masterUrls.includes(page.url)))) addMenuSection('Masters', 'pi pi-briefcase');
    if (pageFeatures.some(page => (page.permission && settingUrls.includes(page.url)))) addMenuSection('Settings', 'pi pi-cog');
    if (pageFeatures.some(page => (page.permission && reportUrls.includes(page.url)))) addMenuSection('Reports', 'pi pi-chart-bar');

    pageFeatures.forEach(page => {
        if (page.permission && page.url !== "skip") {
            let category = 'Dashboard';
            if (leadUrls.includes(page.url)) category = 'Lead';
            else if (masterUrls.includes(page.url)) category = 'Masters';
            else if (settingUrls.includes(page.url)) category = 'Settings';
            else if (reportUrls.includes(page.url)) category = 'Reports';

            breadcrumb.push({
                path: "/" + page.url,
                parent: category,
                label: page.label
            });

            let menuItem = {
                label: page.label,
                icon: 'pi pi-fw pi-circle',
                to: "/" + page.url
            };
            menuMap[category].items.push(menuItem);
        }
    });

    let meta = breadcrumb.find((obj) => {
        return obj.path === location.pathname;
    });

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    // const onInputStyleChange = (inputStyle) => {
    //     setInputStyle(inputStyle);
    // };

    // const changeMenuTheme = (name, logoColor, componentTheme) => {
    //     onMenuThemeChange(name);
    //     changeStyleSheetUrl('theme-css', componentTheme, 2);
    //     setComponentTheme(componentTheme);

    //     const appLogoLink = document.getElementById('app-logo');
    //     const appLogoUrl = `img/logo.svg`;
    //     const horizontalLogoLink = document.getElementById('logo-horizontal');
    //     const horizontalLogoUrl = `img/logo.svg`;

    //     if (appLogoLink) {
    //         appLogoLink.src = appLogoUrl;
    //     }
    //     if (horizontalLogoLink) {
    //         horizontalLogoLink.src = horizontalLogoUrl;
    //     }
    //     setLogoColor(logoColor);
    // };

    // const changeComponentTheme = (theme) => {
    //     setComponentTheme(theme);
    //     changeStyleSheetUrl('theme-css', theme, 3);
    // };

    // const changeColorScheme = (e) => {
    //     setColorScheme(e.value);
    //     const scheme = e.value;
    //     changeStyleSheetUrl('layout-css', 'layout-' + scheme + '.css', 1);
    //     changeStyleSheetUrl('theme-css', 'theme-' + scheme + '.css', 1);
    //     changeLogo(scheme);
    // };

    // const changeStyleSheetUrl = (id, value, from) => {
    //     const element = document.getElementById(id);
    //     const urlTokens = element.getAttribute('href').split('/');

    //     if (from === 1) {
    //         urlTokens[urlTokens.length - 1] = value;
    //     } else if (from === 2) {
    //         if (value !== null) {
    //             urlTokens[urlTokens.length - 2] = value;
    //         }
    //     } else if (from === 3) {
    //         urlTokens[urlTokens.length - 2] = value;
    //     }

    //     const newURL = urlTokens.join('/');
    //     replaceLink(element, newURL);
    // };

    // const changeLogo = (scheme) => {
    //     const appLogoLink = document.getElementById('app-logo');
    //     const mobileLogoLink = document.getElementById('logo-mobile');
    //     const invoiceLogoLink = document.getElementById('invoice-logo');
    //     const footerLogoLink = document.getElementById('footer-logo');
    //     const horizontalLogoLink = document.getElementById('logo-horizontal');
    //     setLogoUrl(`img/logo.svg`);

    //     if (appLogoLink) {
    //         appLogoLink.src = `img/logo.svg`;
    //     }

    //     if (horizontalLogoLink) {
    //         horizontalLogoLink.src = `img/logo.svg`;
    //     }

    //     if (mobileLogoLink) {
    //         mobileLogoLink.src = logoUrl;
    //     }

    //     if (invoiceLogoLink) {
    //         invoiceLogoLink.src = logoUrl;
    //     }

    //     if (footerLogoLink) {
    //         footerLogoLink.src = logoUrl;
    //     }
    // };

    // const replaceLink = (linkElement, href) => {
    //     if (isIE()) {
    //         linkElement.setAttribute('href', href);
    //     } else {
    //         const id = linkElement.getAttribute('id');
    //         const cloneLinkElement = linkElement.cloneNode(true);

    //         cloneLinkElement.setAttribute('href', href);
    //         cloneLinkElement.setAttribute('id', id + '-clone');

    //         linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

    //         cloneLinkElement.addEventListener('load', () => {
    //             linkElement.remove();
    //             const _linkElement = document.getElementById(id);
    //             _linkElement && _linkElement.remove();
    //             cloneLinkElement.setAttribute('id', id);
    //         });
    //     }
    // };

    // const isIE = () => {
    //     return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    // };

    // const onRippleChange = (e) => {
    //     PrimeReact.ripple = e.value;
    //     setRipple(e.value);
    // };

    const onDocumentClick = () => {

        if (!userMenuClick) {
            setTopbarUserMenuActive(false);
        }

        if (!notificationMenuClick) {
            setTopbarNotificationMenuActive(false);
        }

        if (!menuClick) {
            if (isSlim() || isHorizontal()) {
                setMenuActive(false);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                hideOverlayMenu();
            }

            unblockBodyScroll();
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        // searchClick = false;
        configClick = false;
        userMenuClick = false;
        notificationMenuClick = false;
        menuClick = false;
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setTopbarUserMenuActive(false);
        setTopbarNotificationMenuActive(false);

        if (isOverlay()) {
            setOverlayMenuActive((prevOverlayMenuActive) => !prevOverlayMenuActive);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevStaticMenuDesktopInactive) => !prevStaticMenuDesktopInactive);
        } else {
            setStaticMenuMobileActive((prevStaticMenuMobileActive) => !prevStaticMenuMobileActive);
        }

        event.preventDefault();
    };

    const onMenuitemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();

            if (isSlim() || isHorizontal()) {
                setMenuActive(false);
            }
        }
    };

    const onRootMenuitemClick = () => {
        setMenuActive((prevMenuActive) => !prevMenuActive);
    };

    // const onMenuThemeChange = (name) => {
    //     setMenuTheme('layout-sidebar-' + name);
    // };

    // const onMenuModeChange = (e) => {
    //     setMenuMode(e.value);
    //     if (e.value === 'static') {
    //         setStaticMenuDesktopInactive(false);
    //     }
    // };

    const onTopbarUserMenuButtonClick = (event) => {
        userMenuClick = true;
        setTopbarUserMenuActive((prevTopbarUserMenuActive) => !prevTopbarUserMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const onTopbarNotificationMenuButtonClick = (event) => {
        notificationMenuClick = true;
        setTopbarNotificationMenuActive((prevTopbarNotificationMenuActive) => !prevTopbarNotificationMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const onRightMenuButtonClick = (event) => {
        hideOverlayMenu();
        event.preventDefault();
    };

    // const onConfigClick = () => {
    //     configClick = true;
    // };

    // const onConfigButtonClick = () => {
    //     setConfigActive((prevConfigActive) => !prevConfigActive);
    //     configClick = true;
    // };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
        unblockBodyScroll();
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 1091;
    };

    const containerClassName = classNames(
        'layout-wrapper',
        {
            'layout-overlay': menuMode === 'overlay',
            'layout-static': menuMode === 'static',
            'layout-slim': menuMode === 'slim',
            'layout-horizontal': menuMode === 'horizontal',
            'layout-sidebar-dim': colorScheme === 'dim',
            'layout-sidebar-dark': colorScheme === 'dark',
            'layout-overlay-active': overlayMenuActive,
            'layout-mobile-active': staticMenuMobileActive,
            'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
            'p-input-filled': inputStyle === 'filled',
            'p-ripple-disabled': !ripple
        },
        colorScheme === 'light' ? menuTheme : ''
    );


    return (
        <div className={containerClassName} data-theme={colorScheme} onClick={onDocumentClick}>
            {loginObj && <IdleLogout />}
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
            <div className="layout-content-wrapper">
                <AppTopbar
                    meta={meta}
                    topbarNotificationMenuActive={topbarNotificationMenuActive}
                    topbarUserMenuActive={topbarUserMenuActive}
                    onMenuButtonClick={onMenuButtonClick}
                    onTopbarNotification={onTopbarNotificationMenuButtonClick}
                    onTopbarUserMenu={onTopbarUserMenuButtonClick}
                    onRightMenuClick={onRightMenuButtonClick}
                    onRightMenuButtonClick={onRightMenuButtonClick}
                    menu={(loginObj.user_Type !== 2 && loginObj.user_Type !== 3) ? menu : menu.filter(e => e.label === "Modules" || e.label === "Requirement")}
                    menuMode={menuMode}
                    menuActive={menuActive}
                    staticMenuMobileActive={staticMenuMobileActive}
                    onMenuClick={onMenuClick}
                    onMenuitemClick={onMenuitemClick}
                    onRootMenuitemClick={onRootMenuitemClick}
                ></AppTopbar>

                <div className="layout-content">
                    <Routes>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/profile" element={<Profile />} />
                        {hasPermission("LeadAllocation") && <Route path="/leadAllocation" element={<LeadAllocation hasPermission={hasPermission} />} />}
                        {hasPermission("User") && <Route path="/user" element={<User hasPermission={hasPermission} />} />}
                        {hasPermission("Page") && <Route path="/page" element={<Page hasPermission={hasPermission} />} />}
                        {hasPermission("Role") && <Route path="/role" element={<Role hasPermission={hasPermission} />} />}
                        {hasPermission("Lead") && <Route path="/lead" element={<Lead hasPermission={hasPermission} />} />}
                        {hasPermission("MyLead") && <Route path="/mylead" element={<MyLead hasPermission={hasPermission} />} />}
                        {hasPermission("Contact") && <Route path="/contact" element={<Contact hasPermission={hasPermission} />} />}
                        {hasPermission("Source") && <Route path="/source" element={<Source hasPermission={hasPermission} />} />}
                        {hasPermission("Status") && <Route path="/status" element={<Status hasPermission={hasPermission} />} />}
                        {hasPermission("Department") && <Route path="/department" element={<Department hasPermission={hasPermission} />} />}
                        {/* {hasPermission("PaymentMode") && <Route path="/paymentMode" element={<PaymentMode hasPermission={hasPermission} />} />} */}
                        {hasPermission("Device") && <Route path="/device" element={<Device hasPermission={hasPermission} />} />}
                        {hasPermission("Country") && <Route path="/country" element={<Country hasPermission={hasPermission} />} />}
                        {hasPermission("City") && <Route path="/city" element={<City hasPermission={hasPermission} />} />}
                        {hasPermission("State") && <Route path="/state" element={<State hasPermission={hasPermission} />} />}
                        {hasPermission("Subscription_Plan") && <Route path="/subscription_Plan" element={<SubscriptionPlan hasPermission={hasPermission} />} />}
                        {hasPermission("Customer") && <Route path="/customer" element={<Customer hasPermission={hasPermission} />} />}
                        {hasPermission("Plan_Status") && <Route path="/PlanStatus" element={<PlanStatus hasPermission={hasPermission} />} />}
                        {hasPermission("PurposeOfConnection") && <Route path="/purposeOfConnection" element={<PurposeOfConnection hasPermission={hasPermission} />} />}
                        {hasPermission("EmailTemplate") && <Route path="/emailTemplate" element={<EmailTemplate hasPermission={hasPermission} />} />}
                        {hasPermission("Support") && <Route path="/support" element={<Support hasPermission={hasPermission} />} />}
                        {hasPermission("LoginHistory") && <Route path="/loginHistory" element={<LoginHistory hasPermission={hasPermission} />} />}
                        {hasPermission("LeadProgressReport") && <Route path="/leadProgressReport" element={<LeadProgressReport hasPermission={hasPermission} />} />}
                        {hasPermission("EmailTemplate") && <Route path="/emailTemplate" element={<EmailTemplate hasPermission={hasPermission} />} />}

                        {hasPermission("Accessories") && <Route path="/accessories" element={<Accessories hasPermission={hasPermission} />} />}
                        {hasPermission("CustomerReport") && <Route path="/customerReport" element={<CustomerReport hasPermission={hasPermission} />} />}
                        {hasPermission("SalesReport") && <Route path="/salesReport" element={<SalesReport hasPermission={hasPermission} />} />}
                        {hasPermission("RenewalReport") && <Route path="/renewalReport" element={<RenewalReport hasPermission={hasPermission} />} />}
                        {hasPermission("Signature") && <Route path="/signature" element={<Signature hasPermission={hasPermission} />} />}

                        <Route path="*" element={<Navigate to='/dashboard' />} />
                    </Routes>
                </div>
            </div>

            {/* <AppConfig
                configActive={configActive}
                menuMode={menuMode}
                onMenuModeChange={onMenuModeChange}
                colorScheme={colorScheme}
                changeColorScheme={changeColorScheme}
                menuTheme={menuTheme}
                changeMenuTheme={changeMenuTheme}
                componentTheme={componentTheme}
                changeComponentTheme={changeComponentTheme}
                onConfigClick={onConfigClick}
                onConfigButtonClick={onConfigButtonClick}
                rippleActive={ripple}
                onRippleChange={onRippleChange}
                inputStyle={inputStyle}
                onInputStyleChange={onInputStyleChange}
            ></AppConfig> */}
        </div >
    );
};

export default App;
